import { Card, CardHeader, Col, Nav, NavItem, NavLink } from "reactstrap";
import { Buy, Href, Sell } from "../../../../utils/Constant";
import BuySellSectionBody from "./BuySellSectionBody";
import { useState } from "react";

const BuySellSection = () => {
  const [tabId,setTabId] = useState<string>("1")
  return (
    <Col xxl="3" md="6" className="box-col-6 proorder-xl-8 proorder-lg-5">
      <Card className="buysell-section">
        <CardHeader className="card-no-border">
          <Nav pills color="primary" tabs>
            <NavItem>
              <NavLink active={tabId === "1" ? true : false} href={Href} onClick={()=>setTabId("1")}>
                {Buy}
              </NavLink>
            </NavItem>
            <NavItem  className="sell-tab">
              <NavLink active={tabId === "2" ? true : false} href={Href} onClick={()=>setTabId("2")}>
                {Sell}
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <BuySellSectionBody id={tabId} />
      </Card>
    </Col>
  );
};

export default BuySellSection;
